import { RouterReducerState, routerReducer } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';

export interface AppState {
	router: RouterReducerState;
}

export const appReducer: ActionReducerMap<AppState> = {
	router: routerReducer,
};

appReducer;
